module.exports = __webpack_public_path__ + "static/media/bg.9c0455d5.webp";